import { Address } from '../../../../models';

export const ACTIONS = {
  COUNTRY: 'COUNTRY',
  STATE: 'STATE',
  CITY: 'CITY',
  MUNICIPALITY: 'MUNICIPALITY',
  ZIP: 'ZIP',
  ADDRESS1: 'ADDRESS1',
  ADDRESS2: 'ADDRESS2',
  LOCATION: 'LOCATION',
  EXTRA: 'EXTRA',
  PRIMARY: 'PRIMARY',
  DEFAULT: 'DEFAULT',
} as const;

export type ACTIONS_TYPE =
  | { type: 'COUNTRY'; payload: string }
  | { type: 'STATE'; payload: string }
  | { type: 'CITY'; payload: string }
  | { type: 'MUNICIPALITY'; payload: string }
  | { type: 'ZIP'; payload: string }
  | { type: 'ADDRESS1'; payload: string }
  | { type: 'ADDRESS2'; payload: string }
  | { type: 'LOCATION'; payload: string }
  | { type: 'EXTRA'; payload: string }
  | { type: 'PRIMARY'; payload: boolean }
  | { type: 'DEFAULT'; payload: Partial<Address> };

export function reducer(
  state: Partial<Address>,
  action: ACTIONS_TYPE
): Partial<Address> {
  switch (action.type) {
    case ACTIONS.COUNTRY:
      return { ...state, country: action.payload };
    case ACTIONS.STATE:
      return { ...state, state: action.payload };
    case ACTIONS.CITY:
      return { ...state, city: action.payload };
    case ACTIONS.MUNICIPALITY:
      return { ...state, municipality: action.payload };
    case ACTIONS.ADDRESS1:
      return { ...state, address1: action.payload };
    case ACTIONS.ADDRESS2:
      return { ...state, address2: action.payload };
    case ACTIONS.EXTRA:
      return { ...state, extra: action.payload };
    case ACTIONS.PRIMARY:
      return { ...state, primary: action.payload };
    case ACTIONS.ZIP:
      return { ...state, zip: action.payload };
    // case ACTIONS.LOCATION:
    //   return { ...state, location: action.payload };
    case ACTIONS.DEFAULT:
      return { ...state, ...(action?.payload ?? {}) };
    default:
      return { ...state };
  }
}
